<template>
  <section class="mailbox-wrapper">
    <div class="mailbox-container">
      <div>
        <ul class="mailbox-content as">

          <!-- Inbox Folder -->
          <li>
            <router-link to="/emails/inbox" class="d-block plain">
              <object
                class="search-icon chat"
                :data="inboxIcon"
                type="image/png"
              ></object>
              Inbox
              <span class="mail-count"
                >{{ boxCount.inbox }} ></span
              ></router-link
            >
          </li>

          <!-- Unread Folder -->
          <li>
            <router-link to="/emails/unread" class="d-block plain">
              <object
                class="search-icon chat"
                :data="unreadIcon"
                type="image/png"
              ></object>
              Unread
              <span class="mail-count">{{ boxCount.unread }} ></span>
            </router-link>
          </li>

          <!-- Sent Folder -->
          <li>
            <router-link to="/emails/sent" class="d-block plain">
              <object
                class="search-icon chat"
                :data="sentIcon"
                type="image/png"
              >
              </object>
              Sent
            </router-link>
          </li>

          <!-- Draft Folder -->
          <li>
            <router-link to="/emails/draft" class="d-block plain">
              <object
                class="search-icon chat"
                :data="draftsIcon"
                type="image/png"
              ></object>
              Drafts
            </router-link>
          </li>

          <!-- Trash Folder -->
          <li>
            <router-link to="/emails/trash" class="d-block plain">
              <object
                class="search-icon chat"
                :data="trashIcon"
                type="image/png"
              ></object>
              Trash</router-link
            >
          </li>
        </ul>

        <!-- Personalised custom folder list goes here -->
        <a
          href="javascript:void(0);"
          class="show-personal-folder"
          @click="toggleFolders"
          ><object
            class="search-icon chat"
            :data="personalIcon"
            type="image/png"
          ></object>
          <span v-if="!personalFolderToggleState">Show</span
          ><span v-else>Hide</span> personal folders</a
        >
        <ul v-if="personalFolderToggleState" class="sub-folder-container">

          <li v-for="(folder, index) in emailFolderList" :class="{'no-subfolder': folder.folders.length === 0}" :key="index">

            <a href="javascript:void(0);" v-show="folder.folders.length > 0" @click="collapse(folder)">
              <object
                class="search-icon icon-plus-minus"
                :data="(folder.expandFlag === 0) ? iconPlus : iconMinus"
                type="image/png"
              ></object>
            </a>

            <router-link
              @click.native="customFolderName(folder.folderName)"
              :to="'/folder/custom/' + folder.folderId"
              class=" plain"
            >
              <object
                class="search-icon icon-plus-minus"
                :data="folderIcon"
                type="image/png"
              ></object>
              {{ folder.folderName }}
            </router-link>

            <ul v-if="(folder.folders.length > 0) && (folder.expandFlag === 1)">

              <li v-for="(folder1, index1) in folder.folders" :class="{'no-subfolder': folder1.folders.length === 0}" :key="index1">

                <a href="javascript:void(0);" v-show="folder1.folders.length > 0" @click="collapse(folder1)">
                  <object
                    class="search-icon icon-plus-minus"
                    :data="(folder1.expandFlag === 0) ? iconPlus : iconMinus"
                    type="image/png"
                  ></object>
                </a>

                  <router-link
                    @click.native="customFolderName(folder1.folderName)"
                    :to="'/folder/custom/' + folder1.folderId"
                    class=" plain"
                  >
                    <object
                      class="search-icon icon-plus-minus"
                      :data="folderIcon"
                      type="image/png"
                    ></object>
                    {{ folder1.folderName }}
                  </router-link>

                <ul v-if="(folder1.folders.length > 0) && (folder1.expandFlag === 1)">
                  <li
                    v-for="(folder2, index2) in folder1.folders"
                    :key="index2"
                    :class="{'no-subfolder': folder2.folders.length === 0}"
                  >
                    <a href="javascript:void(0);" v-show="folder2.folders.length > 0" @click="collapse(folder2)">
                      <object
                        class="search-icon icon-plus-minus"
                        :data="(folder2.expandFlag === 0) ? iconPlus : iconMinus"
                        type="image/png"
                      ></object>
                    </a>

                    <router-link
                      @click.native="customFolderName(folder2.folderName)"
                      :to="'/folder/custom/' + folder2.folderId"
                      class="plain"
                    >
                      <object
                        class="search-icon icon-plus-minus"
                        :data="folderIcon"
                        type="image/png"
                      ></object>
                      {{ folder2.folderName }}
                    </router-link>

                    <ul
                      v-if="(folder2.folders.length > 0) && (folder2.expandFlag === 1)"
                      class="sub-folder-content"
                    >
                      <li
                        v-for="(folder3, index3) in folder2.folders"
                        :key="index3"
                      >
                        <router-link
                          @click.native="customFolderName(folder3.folderName)"
                          :to="'/folder/custom/' + folder3.folderId"
                          class="d-block plain"
                        >
                          <object
                            class="search-icon icon-plus-minus"
                            :data="folderIcon"
                            type="image/png"
                          ></object>
                          {{ folder3.folderName }}
                        </router-link>
                      </li>
                    </ul>

                  </li>
                </ul>

              </li>

            </ul>

          </li>

        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { nameMixin } from "../../../mixins/nameMixin";
import { mailFolder } from "../../../mixins/mailFolder";

export default {
  name: "MailBoxesSection",
  mixins: [nameMixin, mailFolder],
  data() {
    return {
      emptyStarIcon: require("../../../assets/img/m_favorites-empty.png"),
      filledStarIcon: require("../../../assets/img/m_favorites.png"),
      inboxIcon: require("../../../assets/img/icon-email-inbox.png"),
      unreadIcon: require("../../../assets/img/icon-email-unread.png"),
      favoritesIcon: require("../../../assets/img/icon-email-favourites.png"),
      recentsIcon: require("../../../assets/img/icon-email-recent.png"),
      sentIcon: require("../../../assets/img/icon-email-sent.png"),
      draftsIcon: require("../../../assets/img/icon-email-drafts.png"),
      trashIcon: require("../../../assets/img/icon-email-trash.png"),
      personalIcon: require("../../../assets/img/icon-show-per-folders.png"),
      folderIcon: require("../../../assets/img/icon-for-folder.png"),
      iconMinus: require("../../../assets/img/icon-collapse-folder.png"),
      iconPlus: require("../../../assets/img/icon-expand-folder.png"),
      emailFolderList: [],
      personalFolderToggleState: true
    };
  },
  computed: {
    ...mapGetters("portalemail", {
      emailFolder: "getEmailFolder",
      boxCount: "getBoxCount"
    })
  },
  methods: {
    ...mapMutations("portalemail", {
      setSelectedCustomFolderName: "setSelectedCustomFolderName" // store selected folder name
    }),

    /**
     * Function to collapse/expand custom folders
     */
    collapse(array) {
      let expandFlag = array.expandFlag === 0 ? 1 : 0;
      if(0 === expandFlag) {
        this.setExpandable(array.folders, expandFlag);
      }
      array.expandFlag = expandFlag;
    },

    /**
     * Sets the current custom folder name
     */
    customFolderName(folderName) {
      this.setSelectedCustomFolderName(folderName);
    },

    /**
     * Function to hide/show the folder list
     */
    toggleFolders() {
      this.personalFolderToggleState = !this.personalFolderToggleState;
    },

    /**
     * Go to a specific chat
     */
    goToChat(fullID) {
      const [userOrGroup, id] = fullID.split(":");
      if (userOrGroup === "group") {
        return this.$router.push(`/messenger/group/${id}`);
      }
      return this.$router.push(`/messenger/${id}`);
    },

    /**
     * Filter the list accoding to the type of list required
     */
    filterUserList(userRole) {
      switch (this.show) {
        case "all":
          return true;

        case "client":
          return userRole === "CLIENT_PORTAL_USER";

        case "person":
          return userRole === "NON_CLIENT_PORTAL_USER";

        case "group":
          return !userRole;

        case "user":
          return (
            userRole === "APP_USER" ||
            userRole === "SINGLE_SUBSCRIBER" ||
            userRole === "GROUP_PRACTICES_SUBSCRIBER" ||
            userRole === "GOI"
          );

        default:
          break;
      }
    },

    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
  },

  /**
   * Created hook which will get called when the componet is created.
   */
  created() {
    if(this.emailFolder) {
      this.emailFolderList = this.setExpandable(JSON.parse(JSON.stringify(this.emailFolder)), 0);
    } else {
      this.emailFolderList = [];
    }
  }
};
</script>

<style scoped>
.folderTreeImg {
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  height: 16px;
  width: 16px;
  padding: 0;
}
.mailbox-wrapper {
  margin: 110px 0;
}
section ul {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 0px;
}

.reduce-header {
  margin-top: 93px !important;
}

section ul li {
  list-style: none;
  padding: 15px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.img-star {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 1rem;
}

section ul li.online {
  border-right: 5px solid lightgreen;
}

section ul li:hover {
  /* background-color: rgba(210, 109, 19, 0.1); */
  cursor: pointer;
}
.mailbox-content {
  margin-bottom:12px;
}
.mailbox-content li{
  width:100%;
  padding:15px 0!important;
  margin:0 auto;
  border-bottom:1px solid #f2f2f2;
  line-height: 24px;
}
.mailbox-content li a{
  width:98%;
  margin:0 auto;
}
.mailbox-content li span.mail-count{
  float:right;
  text-align:right;
  position:relative;
  top:10px;
}
.mailbox-content li a object.search-icon.chat, a.show-personal-folder object.search-icon.chat{
  width:28px;
  top:7px;
}
a.show-personal-folder span{
  padding-left:5px;
}
section ul li div.mailbox-content.no-star {
  max-width: 100%;
}

section ul li div.mailbox-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-width: 90%;
}

section ul li div.mailbox-content div.title {
  display: flex;
  margin-bottom: 3px;
}

section ul li div.mailbox-content div.content {
  display: flex;
}

section ul li div.mailbox-content div.content span.message {
  color: gray;
  font-size: 13px;
  flex-grow: 1;
  max-width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
}

section ul li div.mailbox-content div.content span.new-messages {
  font-size: 10px;
  background-color: rgb(210, 109, 19);
  width: 20px;
  height: 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}

section ul li div.mailbox-content div.title span.name {
  flex-grow: 1;
  font-weight: lighter;
  color: #383838;
}

section ul li div.mailbox-content div.title span.time {
  font-size: 13px;
  font-weight: lighter;
  color: gray;
}

.swipe-enter-active {
  animation: swipeIn 0.4s ease-in-out;
}

.swipe-leave-active {
  animation: swipeOut 0.4s ease-in-out;
}

.swipe-move {
  transition: all 0.4s ease-in-out;
}

.loader-container-small {
  padding: 1px 7px 0px 0px;
  margin-right: 0.7rem;
}

.loader-small {
  float: left;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #d26d13;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.5s linear infinite;
}
a.show-personal-folder{
  margin-left:16px;
}
.sub-folder-container{
  margin:0 18px;
}
.sub-folder-container li{
  align-items:start;
   padding:10px 5px 5px 24px;
  display:block;
}
.sub-folder-container li a .icon-plus-minus{
  width:18px;
    padding-right: 3px;

}
.sub-folder-container > li{
      border-bottom:1px solid #f2f2f2;
      line-height: 24px;
}
.sub-folder-container li > a{
    font-size:15px;
}
.sub-folder-container li ul{
  margin:0 10px 0 27px!important;
}
.sub-folder-container li ul li{
  padding:5px 5px;
}
.sub-folder-container li .sub-folder-content{
  margin:5px 0 0 0;
}
.sub-folder-container li .sub-folder-content li{
  padding:0px;
  background:none!important;
}
.sub-folder-container li .sub-folder-content li a{
    font-size:13px;
  color:#d26d13;
  display:block;
  margin:5px 0;
  line-height: 24px;
}
.sub-folder-container li .sub-folder-content li:last-child{
  border-bottom:none;
}
.no-subfolder{
  position:relative;
  left:16px;
}

@keyframes swipeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@media screen and (max-width:767px){
  .mailbox-content li{
  width:97%;
  padding:15px 6px!important;
}
a.show-personal-folder{
  margin-left:10px
}
}
</style>
